import { useEffect, useRef, useState } from "react";

type UseOutsideClickHandler = () => void;

const useOutsideClick = (
  handler: UseOutsideClickHandler,
  listenCapturing: boolean = true,
  isHovered: boolean = false // Hover state is added as while hovering Display Name is visible
) => {
  const ref = useRef<any>(null);
  const [isClickedOutside, setIsClickedOutside] = useState(false);

  useEffect(() => {
    const handleClick = (e: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(e.target) && !isHovered) {
        handler();
        setIsClickedOutside(true);
      } else {
        setIsClickedOutside(false);
      }
    };
    document.addEventListener("click", handleClick, listenCapturing);
    document.addEventListener("touchstart", handleClick, listenCapturing);

    return () => {
      document.removeEventListener("click", handleClick, listenCapturing);
      document.removeEventListener("touchstart", handleClick, listenCapturing);
    };
  }, [handler, listenCapturing, isHovered, isClickedOutside]);

  return { ref, isClickedOutside };
};

export default useOutsideClick;
